import { render, staticRenderFns } from "./RseSection.vue?vue&type=template&id=0bf269c1&scoped=true&"
import script from "./RseSection.vue?vue&type=script&lang=js&"
export * from "./RseSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf269c1",
  null
  
)

export default component.exports